import React from "react";
import { t } from "../../../utils/i18n";
const bcloader = require("../../../../assets/images/bcloader.gif");

const BCLoader = () => {
  return (
    <div id="bcloader-cont">
      <div className="bcloader-section">
        <p className="bc-loader">
          <img src={bcloader} alt={t("p2p.common.loader_alt")}/>
        </p>
      </div>
    </div>
  )
}

export default BCLoader;
